<main class="container mt-4">
    <div class="row">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="./catalog">Catalog</a></li>
                <li *ngIf="product" class="breadcrumb-item active" aria-current="page">
                    {{ product.brand == 'Private Label' ? 'Custom' : product.brand }}
                    {{product.style}}</li>
            </ol>
        </nav>
    </div>
    <ng-container *ngIf="product; else notAvailable">
        <div class="card-body">
            <mdb-lightbox class="lightbox">
                <div class="row">
                    <div class="col-md-2 side-images overflow-scroll d-none d-md-block">
                        <ng-container
                            *ngIf="selectedVariant && (selectedVariant.images?.front || selectedVariant.images?.back || selectedVariant.images?.side)">
                            <div class="col-md-12">
                                <ng-container *ngIf="selectedVariant.images?.side">
                                    <img mdbLightboxItem [src]="selectedVariant.images.side" alt="Side Image"
                                        class="img-fluid" loading="lazy"
                                        (click)="selectCurrentImage(selectedVariant.images.side)" />
                                </ng-container>
                            </div>
                            <div class="col-md-12">
                                <ng-container *ngIf="selectedVariant.images?.front">
                                    <img mdbLightboxItem [src]="selectedVariant.images.front" alt="Front Image"
                                        class="img-fluid" loading="lazy"
                                        (click)="selectCurrentImage(selectedVariant.images.front)" />
                                </ng-container>
                            </div>
                            <div class="col-md-12">
                                <ng-container *ngIf="selectedVariant.images?.back">
                                    <img mdbLightboxItem [src]="selectedVariant.images.back" alt="Back Image"
                                        class="img-fluid" loading="lazy"
                                        (click)="selectCurrentImage(selectedVariant.images.back)" />
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-md-5 d-none d-md-block">
                        <ng-container *ngIf="selectedImageUrl">
                            <img mdbLightboxItem
                                onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';"
                                [src]="selectedImageUrl" alt="Selected Image" class="img-fluid" loading="lazy" />
                        </ng-container>
                    </div>
                    <div class="col-12 col-md-5">
                        <div class="row">
                            <div class="col-12">
                                <span class="pd-product-title">
                                    {{ product.brand == 'Private Label' ? 'Custom' : product.brand }}
                                    {{ product.style }}
                                    {{ product.title | titlecase }}
                                </span>
                            </div>
                        </div>
                        <div class="row d-md-none">
                            <div class="col-4 side-images mobile overflow-scroll">
                                <ng-container
                                    *ngIf="selectedVariant && (selectedVariant.images?.front || selectedVariant.images?.back || selectedVariant.images?.side)">
                                    <div class="w-100">
                                        <ng-container *ngIf="selectedVariant.images?.side">
                                            <img mdbLightboxItem [src]="selectedVariant.images.side" alt="Side Image"
                                                class="img-fluid" loading="lazy"
                                                (click)="selectCurrentImage(selectedVariant.images.side)" />
                                        </ng-container>
                                    </div>
                                    <div class="w-100">
                                        <ng-container *ngIf="selectedVariant.images?.front">
                                            <img mdbLightboxItem [src]="selectedVariant.images.front" alt="Front Image"
                                                class="img-fluid" loading="lazy"
                                                (click)="selectCurrentImage(selectedVariant.images.front)" />
                                        </ng-container>
                                    </div>
                                    <div class="w-100">
                                        <ng-container *ngIf="selectedVariant.images?.back">
                                            <img mdbLightboxItem [src]="selectedVariant.images.back" alt="Back Image"
                                                class="img-fluid" loading="lazy"
                                                (click)="selectCurrentImage(selectedVariant.images.back)" />
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="col-8">
                                <ng-container *ngIf="selectedImageUrl">
                                    <img mdbLightboxItem
                                        onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';"
                                        [src]="selectedImageUrl" alt="Selected Image" class="img-fluid"
                                        loading="lazy" />
                                </ng-container>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-4">
                                <div class="">Color:
                                    <span class="h6" placeholder="Select a Color">
                                        {{ selectedVariant?.colorName ?? ('Select a Color' | titlecase) }}
                                    </span>
                                    <div class="row">
                                        <ng-container *ngFor="let variant of product.variants">
                                            <div class="col-md-1 col-3"
                                                *ngIf="variant && (product.useImages || variant.colorHex?.length > 0 || variant.images?.front?.length > 0)">
                                                <ng-container *ngIf="product.useImages else useColorHex">
                                                    <img onError="this.onerror=null;this.src='https://img.stokkup.com/app/no-image.png';"
                                                        [src]="variant.images?.front" class="img-fluid cursor-pointer"
                                                        [mdbTooltip]="variant.colorName"
                                                        (click)="selectProductColor(variant)" loading="lazy">
                                                </ng-container>
                                                <ng-template #useColorHex>
                                                    <ng-container
                                                        *ngIf="variant.colorHex?.length > 0 else variantImgAsColorHex">
                                                        <span class="img-fluid color-hex cursor-pointer"
                                                            [ngStyle]="{'background': variant.colorHex}"
                                                            [mdbTooltip]="variant.colorName"
                                                            (click)="selectProductColor(variant)"></span>
                                                    </ng-container>
                                                    <ng-template #variantImgAsColorHex>
                                                        <img *ngIf="variant.images?.front?.length > 0"
                                                            [src]="variant.images.front"
                                                            class="img-fluid zoom-effect cursor-pointer"
                                                            [mdbTooltip]="variant.colorName"
                                                            (click)="selectProductColor(variant)" loading="lazy">
                                                    </ng-template>
                                                </ng-template>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-2">
                            <ng-container *ngIf="inventory">
                                <div class="col-md-12">
                                    <span class="pd-inventory-title">Inventory </span><span
                                        class="pd-inventory-value">{{ selectedVariant?.colorName | titlecase }}</span>
                                    <span class="pd-inventory-ts" *ngIf="selectedVariant?.colorName"> Last Updated {{
                                        inventory[selectedVariant.colorName] &&
                                        inventory[selectedVariant.colorName].length ?
                                        (inventory[selectedVariant.colorName][0].lastUpdatedAt | date:
                                        'medium') : 'N/A' }}
                                    </span>
                                </div>
                                <div class="col-12">
                                    <div class="d-flex" *ngIf="selectedVariant?.colorName">
                                        <div class="d-flex flex-column flex-grow-1"
                                            *ngFor="let item of inventory[selectedVariant.colorName]; trackBy: trackSizeByFn">
                                            <span class="pd-inventory-header text-center p-3">{{
                                                item.sizeName }}</span>
                                            <span class="pd-inventory-counts text-center p-3">{{
                                                item.totalQty == 0 ? 'Out of Stock' : item.totalQty
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="authenticated; else redirect">
                                <div class="row" *ngIf="isCustomizable; else requestProduct">
                                    <button class="btn pd-btn mt-4" (click)="navigateToCustomize()">Customize</button>
                                </div>
                        </ng-container>

                        <div class="row">
                            <div class="col-md-12 mt-4 vh-25 overflow-scroll">
                                <h6>Product Details:</h6>
                                <div class="pd-description" [innerHTML]="product.description"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </mdb-lightbox>
        </div>
    </ng-container>
</main>
<ng-template #redirect>
    <div class="row" *ngIf="isCustomizablePublic">
        <button class="btn pd-btn mt-4" (click)="redirectLogin()">Login to Customize</button>
    </div>
</ng-template>

<ng-template #notAvailable>
    <div class="card-body ">
        <div class="text-center mt-5">
            <img src="https://img.stokkup.com/app/stokkup-badge-logo-gold.png" alt="Product Not Available Image"
                class="img-fluid na" loading="lazy" />
        </div>
        <div class="text-center mt-5 na">
            <h1>Product Not Available</h1>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="screenWidth > 991; else mobileView">
    <section class="row mt-4 p-4">
        <ng-container *ngIf="section1">
            <h3 class="base-font fs-4">{{productSectionName1}}</h3>
            <div class="d-flex justify-content-between">
                <div class="clearfix d-flex align-items-center pe-2">
                    <i class="fas fa-chevron-left float-start" (click)="scrollLeft(overflowSection1)"
                        *ngIf="section1.length > 6"></i>
                </div>
                <div class="custom-scroll-main" #overflowSection1>
                    <div class="col-sm-2" *ngFor="let product of section1">
                        <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
                            <a href="{{product.url}}">
                                <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                                    [alt]="'Product Image of ' + product.brand + ' ' + product.styleId + ' - ' + product.name" />
                                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                            </a>
                            <div class="">
                                <span class="fw-bold">
                                    {{ product.brand }}
                                </span>
                                <span>
                                    {{ product.styleId }} {{ product.name }}
                                </span>
                            </div>
                            <div>
                                <span class="fw-lighter">
                                    in {{ product.category }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix d-flex align-items-center pe-2">
                    <i class="fas fa-chevron-right float-end" (click)="scrollRight(overflowSection1)"
                        *ngIf="section1.length > 6"></i>
                </div>
            </div>
        </ng-container>
    </section>
    <section class="row mt-4 p-4">
        <ng-container *ngIf="section2">
            <h3 class="base-font fs-4">{{productSectionName2}}</h3>
            <div class="d-flex justify-content-between">
                <div class="clearfix d-flex align-items-center pe-2">
                    <i class="fas fa-chevron-left float-start" (click)="scrollLeft(overflowSection2)"
                        *ngIf="section2.length > 6"></i>
                </div>
                <div class="custom-scroll-main" #overflowSection2>
                    <div class="col-sm-2" *ngFor="let product of section2">
                        <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
                            <a href="{{product.url}}">
                                <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                                    [alt]="'Product Image of ' + product.brand + ' ' + product.styleId + ' - ' + product.name" />
                                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                            </a>
                            <div class="">
                                <span class="fw-bold">
                                    {{ product.brand }}
                                </span>
                                <span>
                                    {{ product.styleId }} {{ product.name }}
                                </span>
                            </div>
                            <div>
                                <span class="fw-lighter">
                                    in {{ product.category }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix d-flex align-items-center pe-2">
                    <i class="fas fa-chevron-right float-end" (click)="scrollRight(overflowSection2)"
                        *ngIf="section2.length > 6"></i>
                </div>
            </div>
        </ng-container>
    </section>
    <section class="row mt-4 p-4 mb-4">
        <ng-container *ngIf="section3">
            <h3 class="base-font fs-4">{{productSectionName3}}</h3>
            <div class="d-flex justify-content-between">
                <div class="clearfix d-flex align-items-center pe-2">
                    <i class="fas fa-chevron-left float-start" (click)="scrollLeft(overflowSection3)"
                        *ngIf="section3.length > 6"></i>
                </div>
                <div class="custom-scroll-main" #overflowSection3>
                    <div class="col-sm-2" *ngFor="let product of section3">
                        <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
                            <a href="{{product.url}}">
                                <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                                    [alt]="'Product Image of ' + product.brand + ' ' + product.styleId + ' - ' + product.name" />
                                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                            </a>
                            <div class="">
                                <span class="fw-bold">
                                    {{ product.brand }}
                                </span>
                                <span>
                                    {{ product.styleId }} {{ product.name }}
                                </span>
                            </div>
                            <div>
                                <span class="fw-lighter">
                                    in {{ product.category }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix d-flex align-items-center pe-2">
                    <i class="fas fa-chevron-right float-end" (click)="scrollRight(overflowSection3)"
                        *ngIf="section3.length > 6"></i>
                </div>
            </div>
        </ng-container>
    </section>
</ng-container>

<ng-template #mobileView>
    <div class="row mt-4">
        <ng-container *ngIf="section1">
            <h3 class="base-font fs-4">{{productSectionName1}}</h3>
            <div class="custom-scroll">
                <div *ngFor="let product of section1" class="col-12">
                    <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
                        <a href="{{product.url}}">
                            <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                                [alt]="'Image of ' + product.brand + ' ' + product.styleId + ' ' +  product.name" />
                            <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                        </a>
                    </div>
                    <div class="">
                        <span class="fw-bold">
                            {{ product.brand }}
                        </span>
                        <span class="text-wrap">
                            {{ product.styleId }} {{ product.name }}
                        </span>
                    </div>
                    <div>
                        <span class="fw-lighter">
                            in {{ product.category }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="row mt-4">
        <ng-container *ngIf="section2">
            <h3 class="base-font fs-4">{{productSectionName2}}</h3>
            <div class="custom-scroll">
                <div *ngFor="let product of section2" class="col-12">
                    <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
                        <a href="{{product.url}}">
                            <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                                [alt]="'Image of ' + product.brand + ' ' + product.styleId + ' ' +  product.name" />
                            <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                        </a>
                    </div>
                    <div class="">
                        <span class="fw-bold">
                            {{ product.brand }}
                        </span>
                        <span class="text-wrap">
                            {{ product.styleId }} {{ product.name }}
                        </span>
                    </div>
                    <div>
                        <span class="fw-lighter">
                            in {{ product.category }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="row mt-4">
        <ng-container *ngIf="section3">
            <h3 class="base-font fs-4">{{productSectionName3}}</h3>
            <div class="custom-scroll">
                <div *ngFor="let product of section3" class="col-12">
                    <div class="bg-image hover-overlay ripple rounded px-1" data-mdb-ripple-color="light">
                        <a href="{{product.url}}">
                            <img loading="lazy" src="{{product.productImage.fields.file.url}}" class="img-fluid"
                                [alt]="'Image of ' + product.brand + ' ' + product.styleId + ' ' +  product.name" />
                            <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                        </a>
                    </div>
                    <div class="">
                        <span class="fw-bold">
                            {{ product.brand }}
                        </span>
                        <span class="text-wrap">
                            {{ product.styleId }} {{ product.name }}
                        </span>
                    </div>
                    <div>
                        <span class="fw-lighter">
                            in {{ product.category }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #requestProduct>
    <div class="row">
        <button class="btn pd-btn mt-4" (click)="navigateToCustomize()" disabled>Not Currently Available to
            Customize</button>
    </div>
    <div class="row mt-2">
        <div class="pd-description d-flex align-items-center justify-content-center mt-2"><b>Want to customize this
                product on the Design Tool?</b>
        </div>
    </div>
    <div class="row mt-2">
        <div *ngIf="!requestSubmitted" class="d-flex align-items-center justify-content-center">
            <button mdbButton class="btn btn-primary" style="background-color: #032c4a;"
                (click)="requestProductToDesignTool()">Request<i class="far fa-envelope ms-2"></i></button>
        </div>
        <div *ngIf="requestSubmitted" class="d-flex align-items-center justify-content-center">
            <button mdbButton class="btn btn-outline-primary">Thank you for submitting your request!<i
                    class="fas fa-check ms-2" style="color: green"></i></button>
        </div>
    </div>
</ng-template>